import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '../common/BaseComponent';

@Component({
  selector: 'app-invalid-request',
  templateUrl: './invalid-request.component.html',
  styles: [
  ]
})
export class InvalidRequestComponent extends BaseComponent implements OnInit{

  constructor(injector: Injector) { super(injector);}

  ngOnInit(): void {}
}
